import React from "react";
import { Breadcrumb } from "antd";
import { useContext } from "react";
import ReconciliationBankNotesContext from "./ReconciliationBankNotesContext";
import { useState } from "react";
import DynamicSelect from "../../shared/DynamicSelect";
import NumberInput from "../../shared/NumberInput";
import { getDenominationStyles } from "../../../styles/banknotes-styles";
import { formatToCommaSeparate, formatToCurrency, parseFormattedNumber } from "../../../helpers/FormatHelper";
import { saveVaultReconciliation } from "../../../networking/NetworkingBankNotes";
import { getBNVaultBalances } from "../../../networking/NetworkingOrders";
import { DeleteTwoTone } from "@material-ui/icons";
import { equalsIgnoreCase } from "../../../helpers/StringHelper";

const denominationStyles = getDenominationStyles();

const DenominationsView = (props) => {
    
    const { denominations, rowId, item, removeItem, enableRemove, allowEditDenominations, showDifferences } = props;
    const [refresh, setRefresh] = useState(false);

    let editDenominations = [];

    item.ReconciliationDenominations = item.ReconciliationDenominations || [];

    if (Array.isArray(denominations) && denominations.length > 0) {
        editDenominations = denominations.map((d, idx) => {
            const denominationItem = (item.ReconciliationDenominations || []).find(
                (r) => r.DenominationDescription === d.DenominationDescription
            );
            if (denominationItem === undefined) {
                item.ReconciliationDenominations.push({
                    DenominationDescription: d.DenominationDescription,
                    ReportedNoNotes: 0,
                });
            }      
            return (
                <div
                    id={`eo-div-details-rows-${rowId}-den-${idx}-root-${d.DenominationDescription}`}
                    key={`eo-div-details-rows-${rowId}-den-${idx}-root-${d.DenominationDescription}`}
                >
                    <div
                        id={`eo-div-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                        key={`eo-div-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                        style={denominationStyles.processingRowHeader}
                    >
                        {d.DenominationDescription}
                    </div>

                    {showDifferences && <div
                        id={`eo-div-in-details-rows-${rowId}-den-${idx}-diff-${d.DenominationDescription}`}
                        key={`eo-div-in-details-rows-${rowId}-den-${idx}-diff-${d.DenominationDescription}`}
                    >
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-${idx}-diff-${d.DenominationDescription}`}
                            key={`eo-in-details-rows-${rowId}-den-${idx}-diff-${d.DenominationDescription}`}
                            className="uk-input"
                            type="Currency"
                            value={denominationItem !== undefined && Number(denominationItem.InventoryNoNotes) > 0 ? formatToCommaSeparate(denominationItem.InventoryNoNotes) : '0'}
                            onChange={f => f}
                            disabled={true}
                            scale={0}
                            style={denominationStyles.processingRowCellDisabled}
                        />
                    </div>}

                    <div
                        id={`eo-div-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                        key={`eo-div-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                    >
                        <NumberInput
                            id={`eo-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                            key={`eo-in-details-rows-${rowId}-den-${idx}-edit-${d.DenominationDescription}`}
                            className="uk-input"
                            type="Currency"
                            value={
                                formatToCommaSeparate(denominationItem !== undefined && Number(denominationItem.ReportedNoNotes) > 0
                                    ? denominationItem.ReportedNoNotes
                                    : "")
                            }
                            onChange={(event) => {
                                if (
                                    event.target.value === "" ||
                                    event.target.value === null ||
                                    event.target.value === undefined
                                ) {
                                    return;
                                }
                                const denominationItem = item.ReconciliationDenominations.find(
                                    (r) => r.DenominationDescription === d.DenominationDescription
                                );                                                                  
                                item.ReportedValue = (item.ReportedValue || 0) - (denominationItem.ReportedNoNotes || 0) * d.DenominationValue;                                
                                denominationItem.ReportedNoNotes = Number(event.target.value);
                                item.ReportedValue = (item.ReportedValue || 0) + denominationItem.ReportedNoNotes * d.DenominationValue;                                
                                setRefresh((refresh) => !refresh);
                            }}
                            disabled={!allowEditDenominations}
                            onBlur={() => {
                                setRefresh((refresh) => !refresh);
                            }}
                            scale={0}
                            style={denominationStyles.processingRowCell}
                        />
                    </div>
                    
                </div>
            );
        });

        
        showDifferences && editDenominations.unshift(
            <div
                id={`eo-root-details-rows-${rowId}-den-reportedvalue-label`}
                key={`eo-root-details-rows-${rowId}-den-reportedvalue-label`}
            >
                <div style={denominationStyles.processingRowHeader}>
                    &nbsp;
                </div>
                <div
                    id={`eo-div-details-rows-${rowId}-den-instock-label`}
                    key={`eo-div-details-rows-${rowId}-den-instock-label`}
                    style={denominationStyles.processingRowHeader}
                >
                    In Stock
                </div>
                <div
                    id={`eo-div-details-rows-${rowId}-den-reportedvalue-label`}
                    key={`eo-div-details-rows-${rowId}-den-reportedvalue-label`}
                    style={denominationStyles.processingRowHeader}
                >
                    Reported
                </div>
            </div>
        );

        editDenominations.push(
            <div
                id={`eo-root-details-rows-${rowId}-den-reportedvalue-edit`}
                key={`eo-root-details-rows-${rowId}-den-reportedvalue-edit`}
                style={{'marginLeft': 'auto'}}
            >
                <div
                    id={`eo-div-details-rows-${rowId}-den-reportedvalue-edit`}
                    key={`eo-div-details-rows-${rowId}-den-reportedvalue-edit`}
                    style={denominationStyles.processingRowHeader}
                >
                    Total
                </div>                
                {
                    showDifferences &&
                    <div
                        id={`eo-div-details-rows-${rowId}-den-reportedvalue-showDifferences`}
                        key={`eo-div-details-rows-${rowId}-den-reportedvalue-showDifferences`}
                        style={denominationStyles.processingRowCellTotal}
                    >
                        <input
                            id={`eo-div-details-rows-${rowId}-den-reportedvalue-showDifferences-in`}
                            key={`eo-div-details-rows-${rowId}-den-reportedvalue-showDifferences-in`}
                            disabled
                            className="uk-input"
                            value={item.InventoryValue === item.ReportedValue ? 'No Differences' : 'With Differences'}
                        />
                    </div>
                }
                <div>
                    <NumberInput
                        id={`eo-in-details-rows-${rowId}-den-reportedvalue-edit`}
                        key={`eo-in-details-rows-${rowId}-den-reportedvalue-edit`}
                        className={"uk-input"}
                        type="Currency"
                        value={formatToCurrency(item.ReportedValue || 0)}
                        disabled={true}
                        style={denominationStyles.processingRowCellTotal}
                    />
                </div>
            </div>
        );
        enableRemove && editDenominations.push(
            <div
                id={`eo-root-details-rows-${rowId}-den-reportedvalue-action`}
                key={`eo-root-details-rows-${rowId}-den-reportedvalue-action`}
            >
                <div
                    id={`eo-div-details-rows-${rowId}-den-reportedvalue-action`}
                    key={`eo-div-details-rows-${rowId}-den-reportedvalue-action`}
                    style={denominationStyles.processingRowHeader}
                >
                    &nbsp;
                </div>
                <div>
                    <DeleteTwoTone
                        style={denominationStyles.processingRowAction}
                        id={`eo-div-details-rows-delete-${rowId}`} key={`eo-div-details-rows-delete-${rowId}`}
                        onClick={() => { removeItem(item) }
                        } />
                </div>
            </div>
        );
    }

    return (
        <div style={denominationStyles.processingRow}>{editDenominations}</div>
    );
};

const ReconciliationItem = (props) => {

    const { index, item, loadCurrencyDenominations, currencies, editingRow, removeItem, enableRemove, allowEditDenominations, showDifferences } = props;

    const [currency, setCurrency] = useState({});    
    const [refresh, setRefresh] = useState(false);

    const onSelectCurrency = (event) => {
        let value = event.value;
        setCurrency(value);

        loadCurrencyDenominations(item, value);
        setRefresh(!refresh);
    };

    let denominationView = [];

    let itemDenominations = item.ReconciliationDenominations || [];
    if (itemDenominations && Array.isArray(itemDenominations)) {
        denominationView.push(
            <DenominationsView
                key={`recon-row-${index}`}
                rowId={index}
                denominations={itemDenominations}
                currency={currency}
                item={item}
                currencies={currencies}
                onSelectCurrency={onSelectCurrency}
                removeItem={removeItem}
                enableRemove={enableRemove}
                allowEditDenominations={allowEditDenominations}
                showDifferences={showDifferences}
            />
        );
    }

    return (
        <>
            <div style={{ display: "flex", direction: "row", alignItems: "center", gap: "2rem", width: '75%',  }}>
                <>{editingRow && item.CurrencyID !== '' ?
                    <div style={denominationStyles.processingRowHeaderCurrency}>{item.CurrencyID}</div> :
                    <DynamicSelect
                        id={`s-currency-${index}`}
                        className={"uk-select"}
                        placeholder="Select a currency"
                        placeholderValue=""
                        data={currencies}
                        objValue={{ value: currency }}
                        getValue={onSelectCurrency}
                    />}
                </>
                <>
                    {denominationView}
                </>
            </div>
            <hr style={{ margin: '0.1rem' }} />
        </>
    );
};

const ReconciliationBankNotesForm = (props) => {
    const {
        dateReported,
        vaultSelected,
        vaultReconciliationRecord,
        alertMessage,
        setAlertMessage,
        currencyDenominations,
        currencies,
        confirmationMessage,
        setConfirmationMessage,
        isBankNotesAdmin = false,
        loading,
        setLoading,
        showDifferences
    } = useContext(ReconciliationBankNotesContext);

    const reconciliationIsCompleted = equalsIgnoreCase(vaultReconciliationRecord.Status || 'completed', 'Completed')
    const allowSaveInProgress = !reconciliationIsCompleted || isBankNotesAdmin
    const allowEditDenominations = !reconciliationIsCompleted || isBankNotesAdmin    

    const [refresh, setRefresh] = useState(false);    

    const addCurrency = () => {        
        let item = { CurrencyID: "", ReportedValue: 0 };
        vaultReconciliationRecord.ReconciliationItems.push(item);
        setRefresh(!refresh);
    };

    const loadCurrencyDenominations = (item, currencyId) => {

        item.CurrencyID = currencyId;
        const currencyDetails = currencyDenominations.find(
            (c) => c.CurrencyID === currencyId
        );        

        if (currencyDetails && currencyDetails.Denominations) {            
            item.ReconciliationDenominations = currencyDetails.Denominations;
        } else {
            item.ReconciliationDenominations = [];
        }
        setRefresh(!refresh);
    };

    const removeItem = (item) => {
        vaultReconciliationRecord.ReconciliationItems = vaultReconciliationRecord.ReconciliationItems.filter(i => i.CurrencyID !== item.CurrencyID)
        setRefresh(!refresh)
    }

    let recordView = [];
    if (Array.isArray(vaultReconciliationRecord.ReconciliationItems)) {
        let currentSelectedCurrencies = vaultReconciliationRecord.ReconciliationItems.map(item => item.CurrencyID) || []
        recordView = vaultReconciliationRecord.ReconciliationItems.map(
            (item, index) => (
                <ReconciliationItem key={index} item={item} index={index}
                    loadCurrencyDenominations={loadCurrencyDenominations}
                    currencies={currencies.filter(c => !currentSelectedCurrencies.includes(c.value))}
                    editingRow={item.ReconciliationDenominations !== undefined && item.ReconciliationDenominations.length > 0 && item.CurrencyID !== ''}
                    removeItem={removeItem}
                    enableRemove={!reconciliationIsCompleted}
                    allowEditDenominations={allowEditDenominations}
                    showDifferences={showDifferences} />
            )
        );
    }

    const onSave = async (finalSubmit) => {        
        const validationMessage = await validateBalanceStocks(false)
        let message = 'Please confirm all the information is Ok before the final submit. Do you want to proceed'
        if (validationMessage !== '') {
            message = validationMessage
        }
        
        if (finalSubmit) {
            setConfirmationMessage({
                ...confirmationMessage, show: true, title: 'Confirm',
                message: message,
                callback: onFinalSubmit
            }
            )
        } else {
            vaultReconciliationRecord.Status = 'In Progress'
            saveReconciliation()
        }
    }

    const onFinalSubmit = async () => {

        vaultReconciliationRecord.Status = 'Completed'
        vaultReconciliationRecord.StatusVariance = 'No Differences'
        vaultReconciliationRecord.TotalInventoryValue = 0

        const validationMessage = await validateBalanceStocks(true)

        let differences = false;        
        if (validationMessage !== '') {
            differences = true
        }

        if (differences) {
            vaultReconciliationRecord.StatusVariance = 'With Differences'
        }

        saveReconciliation()
    }

    const validateBalanceStocks = async (forFinalSubmit) => {

        let validationMessage = ''
        const vaultId = vaultReconciliationRecord.VaultReconciliationID > 0 ? vaultReconciliationRecord.VaultID : vaultSelected.id
        setLoading(true)
        const response = await getBNVaultBalances({ vaultId });
        setLoading(false)

        if (response && response.result) {

            let differences = false;

            const balances = response.result || []

            const groupedByCurrency = balances.reduce((acc, item) => {
                const currency = item.Currency;
                const inStock = parseFormattedNumber(item['In Stock']) || 0;

                const existingCurrency = acc.find(entry => entry.currency === currency);

                if (existingCurrency) {
                    existingCurrency.stock += (inStock * Number(item['Denomination Description']));
                } else {
                    acc.push({ currency, stock: inStock * Number(item['Denomination Description']) });
                }
                return acc;
            }, []);

            const groupedByCurrencyNoZeroStock = groupedByCurrency.filter((s) => s.stock > 0)

            let currenciesNoReconciliated = []

            groupedByCurrencyNoZeroStock.forEach(s => {
                const item = vaultReconciliationRecord.ReconciliationItems.find(item => s.currency === item.CurrencyID)
                if (item === undefined || item == null) {
                    differences = true;
                    currenciesNoReconciliated.push(
                        {
                            "CurrencyID": s.currency,
                            "InventoryValue": s.stock,
                            "ReportedValue": 0,
                            "ReconciliationDenominations": balances.filter(b => b.Currency === s.currency).map(b => {
                                return {
                                    DenominationDescription: b['Denomination Description'],
                                    InventoryNoNotes: Number(b['In Stock']),
                                    ReportedNoNotes: 0,
                                    DenominationValue: Number(b['Denomination Description'])
                                }
                            })
                        }
                    )
                    return;
                }

                const reportedvalue = item.ReportedValue || 0
                if (s.stock !== reportedvalue) {
                    differences = true;
                }
            })

            if (forFinalSubmit) {
                currenciesNoReconciliated.forEach(c => {                    
                    vaultReconciliationRecord.ReconciliationItems.push(c)
                })

                vaultReconciliationRecord.ReconciliationItems.forEach(item => {
                    const balance = groupedByCurrencyNoZeroStock.find(s => s.currency === item.CurrencyID)
                    item.InventoryValue = balance ? balance.stock : 0
                    if (item.InventoryValue !== item.ReportedValue) {
                        differences = true;
                    }
                })
            }

            if (differences) {
                validationMessage = 'There are differences between reported and in-stock values. Do you want to proceed?'
            }
        } else {
            console.log('Balances no found')
            validationMessage = 'There are differences between reported and in-stock values. Do you want to proceed?'
        }

        return validationMessage;
    }


    const saveReconciliation = async () => {
        vaultReconciliationRecord.TotalReportedValue = vaultReconciliationRecord.ReconciliationItems.reduce((total, item) => total + (item.ReportedValue || 0), 0);   
        setLoading(true)     
        const response = await saveVaultReconciliation(vaultReconciliationRecord.VaultReconciliationID, vaultReconciliationRecord, vaultReconciliationRecord.UpdateToken)
        setLoading(false)
        console.log('saveReconciliation ', response)
        if (response.success) {
            setAlertMessage({ ...alertMessage, show: true, title: 'Sucess', message: `Reconciliation saved successfully` })
            props.back()
        } else {
            setAlertMessage({
                ...alertMessage, show: true, title: 'Error',
                message: response !== undefined
                    ? response.Message
                    : 'Something went wrong. Please try again later.'
            })
        }
    }

    return (
        <div>
            <div className="breadcrumb-div">
                <Breadcrumb separator=">">
                    <Breadcrumb.Item className={"breadcrumb-item"} onClick={props.back}>
                        Reconciliation
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className="breadcrumb-item-bold">{`Date Reported: ${vaultReconciliationRecord.VaultReconciliationID > 0 ? vaultReconciliationRecord.DateReported : dateReported}`}</Breadcrumb.Item>
                </Breadcrumb>
            </div>

            <div className="uk-grid uk-margin uk-width-1-1">
                <div className="uk-width-1-3">
                    <div className="uk-width-1-1">
                        <label className="uk-form-label">Vault</label>
                    </div>
                    <div className="uk-width-1-1">
                        <input
                            id="rc-in-vault-id"
                            disabled
                            className="uk-input"
                            value={vaultReconciliationRecord.VaultReconciliationID > 0 ? (vaultReconciliationRecord.VaultDescription) : `${vaultSelected.name} - ${vaultSelected.id}`}
                        />
                    </div>
                </div>
                <div className="uk-width-1-3">
                    <div className="uk-width-1-1">
                        <label className="uk-form-label">Status</label>
                    </div>
                    <div className="uk-width-1-1">
                        <input
                            id="rc-in-vault-status"
                            disabled
                            className="uk-input"
                            value={vaultReconciliationRecord.Status || ''}
                        />
                    </div>
                </div>
            </div>
            <hr />
            
            <div style={{ display: 'flex', gap: '2rem', flexDirection: 'row' }}>
                {!reconciliationIsCompleted && <button
                    id="rc-b-add-currency"
                    className="uk-button uk-button-green"
                    type="button"
                    onClick={addCurrency}
                    disabled={loading}
                >
                    Add Currency
                </button>}
                {allowSaveInProgress && <button
                    id="rc-b-save"
                    className="uk-button uk-button-green"
                    type="button"
                    onClick={() => onSave(false)}>
                    Save In Progress
                </button>}
                <button
                    id="rc-b-finalsubmit"
                    className="uk-button uk-button-green"
                    type="button"
                    onClick={() => onSave(true)}
                    disabled={reconciliationIsCompleted || loading}>
                    Final Submit
                </button>
            </div>
            <hr style={{marginBottom: '0.1rem'}} />

            <div>{recordView}</div>
        </div>
    );
};

export default ReconciliationBankNotesForm;
